import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NavigationPipe} from "../../pipes/navigation.pipe";
import {OrderHistoryComponent} from "../../UserCabinet/order-history/order-history.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {OrderByPipe} from "../../pipes/order-by.pipe";
import {CountDownComponent} from "../../UserCabinet/order-history/count-down/count-down.component";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";


@NgModule({
  declarations: [
    OrderByPipe,
    NavigationPipe,
    OrderHistoryComponent,
    CountDownComponent
  ],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatMenuTrigger,
    MatMenu,
    NgbTooltip
  ],
  exports: [
    OrderByPipe,
    NavigationPipe,
    OrderHistoryComponent,
    CountDownComponent,
    MatExpansionModule
  ]
})
export class SharedModule { }
